//
//
//
//
import gdApply from "../../applyManage/gdApply/index";
export default {
  components: {
    gdApply: gdApply
  },
  name: 'customerServer'
};